import { render, staticRenderFns } from "./EquipmentPackageLab.vue?vue&type=template&id=1380e8b5&scoped=true&"
import script from "./EquipmentPackageLab.vue?vue&type=script&lang=js&"
export * from "./EquipmentPackageLab.vue?vue&type=script&lang=js&"
import style0 from "./EquipmentPackageLab.vue?vue&type=style&index=0&id=1380e8b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1380e8b5",
  null
  
)

export default component.exports